exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/vendor-specific/vendor-specific.component.css
// module id = ../../../../../src/app/reports/myReports/vendor-specific/vendor-specific.component.css
// module chunks = main